export default __webpack_public_path__ + "static/media/extra_in_d1.dd2c5d46.svg";